// extracted by mini-css-extract-plugin
module.exports = {"Select":"Select--3j69r"};